var jade = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1>included</h1>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources/included.jade
 ** module id = 5
 ** module chunks = 0
 **/